<template>
    <div class="outbox-email-listing">
        <template v-if="isOutboxEmailsFeatureEnabled">
            <TableLoading v-if="isLoading" />
            <template v-else>
                <EmailListingSettingsHeader
                    ref="OutboxEmailsTable"
                    :columns="columns"
                    :totalEmails="emails.length"
                    class="outbox-email-listing__settings-header"
                />
                <EmailListingTable
                    :columns="columns"
                    :emails="formattedEmails"
                    class="outbox-email-listing__table"
                />
            </template>
        </template>
    </div>
</template>
<script>
import TableLoading from 'vcomponents/common/table/TableLoading.vue';
import Feature from 'Services/Feature';
import EmailListingTable from 'vcomponents/email/listings/EmailListingTable.vue';
import EmailListingSettingsHeader from 'vcomponents/email/listings/EmailListingSettingsHeader.vue';
import { getFilteredEmails, deleteEmailById } from 'api/emailEngine/emailEngineService';

export default {
    components: {
        EmailListingTable,
        EmailListingSettingsHeader,
        TableLoading,
    },
    data() {
        return {
            isLoading: true,
            columns: [
                {
                    code: 'participants',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    order: 0,
                    sortKey: 'participants',
                },
                {
                    code: 'subject',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    order: 1,
                    sortKey: 'subject',
                },
                {
                    code: 'status',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    order: 3,
                    sortKey: 'status',
                },
                {
                    code: 'updated',
                    isDefault: true,
                    isMovable: false,
                    isVisible: true,
                    order: 3,
                    sortKey: 'updated',
                },
            ],
            emails: [],
        };
    },
    computed: {
        isOutboxEmailsFeatureEnabled() {
            return Feature.isEnabled('email-engine-outbox');
        },
        formattedEmails() {
            return this.emails.map((email) => {
                return {
                    ...email,
                    participants: email.to.concat(email.cc).concat(email.bcc),
                };
            });
        },
    },
    watch: {
        emails: {
            handler(newEmails) {
                this.$emit('emails-status', newEmails.length > 0);
            },
            immediate: true,
        },
    },
    created() {
        EventBus.on('refreshOutBoxEmailListing', () => {
            this.getOutboxEmails();
        });
        this.getOutboxEmails();
        EventBus.on('delete:email', this.handleDelete);
    },
    beforeDestroy() {
        EventBus.off('refreshOutBoxEmailListing');
        EventBus.off('delete:email', this.handleDelete);
    },
    methods: {
        getOutboxEmails(emailToExclude) {
            this.isLoading = true;
            getFilteredEmails(['outbox'])
                .then((emails) => {
                    this.emails = emails.data.filter((email) => email.id !== emailToExclude);
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        // eslint-disable-next-line vue/no-unused-properties
        handleDelete($event) {
            deleteEmailById($event.id)
                .then(() => {
                    this.$pushToast({
                        close: true,
                        text: this.$t.__('email.ScheduledEmailListing.email_deleted'),
                        type: 'success',
                    });
                    this.getOutboxEmails($event.id);
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.outbox-email-listing {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: var(--spacing-0);
    padding: 0 var(--spacing-3);
    background: var(--colors-common-background-default);

    &__settings-header {
        align-items: center; // to be removed when filters are added to the header
        min-height: 64px;
    }

    &__table {
        padding: 0 0 var(--spacing-2);
        overflow: auto;
    }
}
</style>
